import { faCircleExclamation, faDownload, faFileCsv, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CloudUpload from '@mui/icons-material/CloudUpload';
import { Popper } from "@mui/material";
import TooltipMUI from '@mui/material/Tooltip';
import { css, styled } from '@mui/system';
import { process } from '@progress/kendo-data-query';
import { Button } from '@progress/kendo-react-buttons';
import { setExpandedState, setGroupIds } from '@progress/kendo-react-data-tools';
import { Dialog } from '@progress/kendo-react-dialogs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { GridColumn as Column, Grid, GridColumn, GridColumnMenuFilter, GridColumnMenuGroup, GridColumnMenuSort, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import { Input } from '@progress/kendo-react-inputs';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaInfoCircle } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import FileUpload from '../../components/common/upload/FileUpload';
import LoaderOverlay from '../../components/custom-loader/LoaderOverlay';
import { applyFilter, applySort, flatternGroup } from '../../custom/commonExport';
import { filterString } from '../../custom/filterString';
import Images from '../../custom/flagExport';
import { validateUserData } from '../../custom/UserExport';
import { exportArticleData, getArticleData, getArticleDataBypagination, getArticleOptionsData } from '../../services/article-service/articleService';



const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const mappingFields = {
    "VehicleId": {
        "value": "Vehicle ID",
        "width": "200px"
    },
    "VehicleCount": {
        "value": "Vehicle Count",
        "width": "200px"
    },
    "Make": {
        "value": "Manufacturer",
        "width": "200px"
    },
    "MakeId": {
        "value": "Manufacturer ID",
        "width": "200px"
    },
    "ModelId": {
        "value": "Model ID",
        "width": "200px"
    },
    "Model": {
        "value": "Model Name",
        "width": "200px"
    },
    "Variant": {
        "value": "Variant",
        "width": "200px"
    },
    "EngineCode": {
        "value": "Engine Code",
        "width": "200px"
    },
    "FromDate": {
        "value": "From Date",
        "width": "200px"
    },
    "ToDate": {
        "value": "To Date",
        "width": "200px"
    },
    "ABENr": {
        "value": "ABENr",
        "width": "200px"
    },
    "PowerPS": {
        "value": "Power (PS)",
        "width": "200px"
    },
    "PowerkW": {
        "value": "Power (kW)",
        "width": "200px"
    },
    "CapacityCCM": {
        "value": "Technical Capacity",
        "width": "250px"
    },
    "Capacity": {
        "value": "Capacity",
        "width": "200px"
    },
    "NumberOfValves": {
        "value": "Number of Valves",
        "width": "200px"
    },
    "NoOfCylinders": {
        "value": "Number of Cylinders",
        "width": "200px"
    },
    "BodyType": {
        "value": "Body Type",
        "width": "200px"
    },
    "DriveType": {
        "value": "Drive Type",
        "width": "200px"
    },
    "FuelType": {
        "value": "Fuel Type",
        "width": "200px"
    },
    "FuelMixture": {
        "value": "Fuel Mixture",
        "width": "200px"
    },
    "KBANumber": {
        "value": "KBA Number",
        "width": "200px"
    },
}


const DATA_ITEM_KEY = 'VehicleId';
const initialDataState = {
    filter: { logic: "and", filters: [] },
    take: 100,
    skip: 0,
    sort: [],
    group: [],
};

const processWithGroups = (data, dataState) => {
    const newDateStateChanges = {
        ...dataState,
        filter: { filters: [], logic: "and" },
        skip: 0
    }
    const newDataState = process(data, newDateStateChanges);
    setGroupIds({
        data: newDataState.data,
        group: dataState.group
    });
    return newDataState;
};



function ArticlePage() {
    const location = useLocation()
    const { i18n } = useTranslation();
    const { newYear, newMonth, newRegion } = location.state || {};
    const [show, setShow] = useState(false)
    const [currArticleNo, setCurrArticleNo] = useState('')
    const [vehicleData, setVehicleData] = useState([]);
    const [filterValue, setFilterValue] = useState(null);
    const [collapsedState, setCollapsedState] = useState([]);
    const [isDataAvailable, setIsDataAvailable] = useState(false);
    const [filterValueArticle, setFilterValueArticle] = useState('')
    const [filteredData, setFilteredData] = useState([]);
    const [supplierOptions, setSupplierOptions] = useState([])
    const [filterSupplierOptions, setFilterSupplierOptions] = useState(supplierOptions.slice())
    const [supplierAttributes, setSupplierAttributes] = useState([])
    const [currArticleName, setCurrArticleName] = useState('')
    const [dataState, setDataState] = useState(initialDataState);
    const [totalLength, setTotalLength] = useState(0)
    const [dataResult, setDataResult] = useState({ data: [], total: 0 });
    const [totalGridLength, setTotalGridLength] = useState(0)
    const [anchorEl, setAnchorEl] = useState(null);
    const [visible, setVisible] = useState(false)
    const [isButtonClicked, setIsButtonClicked] = useState(false)
    const [columnFields, SetColumnFields] = useState([])
    const [loading, setLoading] = useState(false);
    const [inputError, setInputError] = useState(false)
    const [selectedSupplierOption, setSelectedSupplierOption] = useState({ SupplierId: null, SupplierName: 'Select a supplier...' });
    const [openToggleModelForUpload, setOpenToggleModelForUpload] = useState(false)
    const anchorRef = useRef(null);
    const popupRef = useRef(null);
    const excelExportRef = useRef(null);
    const [data, setData] = useState([]);
    const [files, setFiles] = useState([]);
    const navigate = useNavigate();





    let userData = validateUserData()

    useEffect(() => {
        if (!userData) {
            navigate('/login');
        }
    }, [userData, navigate]);


    // useEffect(() => {
    //     fetchData();
    // }, [CurrentLanguage]);

    const regions = [
        { id: 1, name: 'Finland', value: "fi", flag: Images["fi"] },
        { id: 2, name: 'Sweden', value: "se", flag: Images["se"] },
    ];
    const accessibleRegions = userData?.RegionAccess ? userData?.RegionAccess.split(',') : [];
    const filteredRegions = regions?.filter((region) => {
        return accessibleRegions?.includes(region?.name)
    })
    const [selectedRegion, setSelectedRegion] = useState(newRegion || null);


    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (e?.target?.classList.contains('k-overlay')) {
                // Access the Dialog's DOM element using ReactDOM.findDOMNode
                setVisible(false)
            }
        }
        if (visible) {
            document.addEventListener('click', handleClickOutside)
        }
        else {
            document.removeEventListener('click', handleClickOutside)
        }
        return () => {
            document.removeEventListener('click', handleClickOutside)
        }
    }, [visible])

    useEffect(() => {
        if (filteredRegions.length > 0 && !selectedRegion) {
            setSelectedRegion(filteredRegions[0]);
        }
    }, [filteredRegions]);


    useEffect(() => {
        const fetchOptions = async () => {
            setLoading(true)
            const response = await getArticleOptionsData({ userData });
            if (response && response?.data?.SupplierInfo?.length > 0) {
                setLoading(false)
                setSupplierOptions(response?.data?.SupplierInfo || [])
                setFilterSupplierOptions(response?.data?.SupplierInfo || [])
            }
            else if (response && response?.status === 401) {
                setLoading(false)
                toast.error('Session Expired.')
                localStorage.removeItem("userData")
                navigate('/login')
            }
            setLoading(false)
        }
        fetchOptions();
    }, [])


    const onFilterChange = (ev) => {
        const value = ev ? ev.value : '';
        const regex = /^[a-zA-Z0-9.\-\\]*$/;
        if (!regex.test(value)) {
            setInputError(true)
        }
        else {
            setInputError(false)
        }
        setFilterValue(value);
    };


    const dataStateChange = useCallback((event) => {
        const newDataState = processWithGroups(filteredData, event.dataState);
        setDataState({
            ...event.dataState,
            skip: dataState.skip
        });
        setDataResult(newDataState);
    }, [filteredData]);

    const itemRender = (li, itemProps) => {
        const item = itemProps.dataItem;
        return (
            <li {...li.props} className="region-item" style={{ cursor: "pointer" }}>
                <img src={item.flag} alt={item.name} style={{ width: '20px', marginRight: '10px' }} />
                {item.name}
            </li>
        );
    };




    const valueRender = (li, itemProps) => {
        if (!itemProps) return null;
        return (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "start", width: "100%" }}>
                <img src={itemProps.flag} alt={itemProps.name} style={{ width: '20px', margin: '0 10px' }} />
                {itemProps.name}
            </div>
        )
    }



    const itemRenderSupplier = (li, itemProps) => {
        const item = itemProps.dataItem;
        return (
            <div style={{ overflow: "auto", borderBottom: "1px solid #ccc", }} >
                <li {...li.props} className="region-item" style={{ cursor: "pointer", borderBottom: "2px" }} >
                    {item?.SupplierName} ({item.SupplierId})
                </li>
            </div>
        );
    };

    const valueRenderSupplier = (li, itemProps) => {
        const item = itemProps;
        return (
            <div style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start"
            }}>
                <li {...li.props} className="region-item" style={{ cursor: "pointer", borderBottom: "2px" }} >
                    {item?.SupplierName} {item?.SupplierId && ` (${item?.SupplierId})`}
                </li>
            </div>
        );
    };



    const exportExcel = async () => {
        const dataStateForExport = {
            ...dataState,
            skip: 0,
            take: Number.MAX_SAFE_INTEGER,
        };
        setLoading(true);
        const pureString = filterString(filterValue)
        const articleNo = filterString(pureString);
        const supplierId = selectedSupplierOption?.SupplierId;
        const supplierName = selectedSupplierOption?.SupplierName || '';
        const region = selectedRegion?.value
        const CurrentLanguage = i18n.language
        const body = {
            articleNo,
            supplierId,
            supplierName,
            region,
            CurrentLanguage,
            filters: dataState?.filter
        }
        const getExcelExportResponse = await exportArticleData({ userData, body })
        if (getExcelExportResponse?.status === 401) {
            localStorage.removeItem("userData")
            navigate('/login')
            toast.error('Session Expired.')
            setLoading(false)
            return;
        }
        else if (getExcelExportResponse?.status !== 200) {
            toast(getExcelExportResponse?.message, {
                type: "info",
                autoClose: true
            })
            setLoading(false)
            return;
        }
        let processedData = getExcelExportResponse?.data || [];


        // Apply filters, grouping, and sorting
        if (dataStateForExport?.filter?.filters.length > 0) {
            processedData = applyFilter(processedData, dataStateForExport?.filter.filters, dataStateForExport?.filter.filters.logic);
        }

        if (dataStateForExport.group.length > 0) {
            const filteredAndGroupedData = process(processedData, dataStateForExport);
            processedData = dataState.group.length > 0 ? flatternGroup(filteredAndGroupedData.data) : processedData;
        }

        if (dataStateForExport?.sort?.length > 0) {
            processedData = applySort(processedData, dataStateForExport.sort);
        }

        if (processedData.length === 0) {
            toast("No data available for export", { type: "warning", autoClose: true });
            setLoading(false);
            return;
        }


        // Prepare data for the first sheet
        const sheet1Data = processedData.map(item => ({
            ...item, // Spread each item to extract key-value pairs
        }));

        const sheet1Headers = Object.keys(sheet1Data[0] || {});

        // Prepare data for the second sheet
        const sheet2Data = supplierAttributes.map(attr => ({
            Attribute: attr.key,
            Value: attr.value,
        }));

        // Define workbook sheets
        const workbook = {
            sheets: [
                {
                    name: `${currArticleNo}_${currArticleName}`,
                    columns: sheet1Headers.map(header => ({
                        autoWidth: true
                    })),
                    rows: [
                        {
                            cells: sheet1Headers.map(header => ({
                                value: header,
                                bold: true,
                                background: "#7A7A7A",
                                color: "#FFFFFF"
                                // Optional styling
                            })),
                        },
                        ...sheet1Data.map(row => ({
                            cells: sheet1Headers.map(header => ({ value: row[header] })),
                        })),
                    ],
                },
                {
                    name: "Supplier Attributes",
                    columns: [
                        { autoWidth: true }, // Set the width for "Attribute" column
                        // Set the width for "Value" column
                    ],
                    rows: [
                        {
                            cells: [
                                { value: "Attribute", bold: true, background: "#7A7A7A", color: "#FFFFFF" },
                                { value: "Value", bold: true, background: "#7A7A7A", color: "#FFFFFF" },
                            ],
                        },
                        ...sheet2Data.map(attr => ({
                            cells: [
                                { value: attr.Attribute },
                                { value: attr.Value },
                            ],
                        })),
                    ],
                },
            ],
        };

        // Trigger export using ExcelExport component
        if (excelExportRef.current) {
            excelExportRef.current.save(workbook);
            setLoading(false);
        } else {
            setLoading(false);
        }
    };



    const handlePopperToggle = (event) => {
        setShow((prev) => !prev);
        anchorRef.current = event.currentTarget;
    };

    const handleOpenModalForUploadFile = (event) => {
        setOpenToggleModelForUpload(true)
    }

    const handleCloseModalForUploadFile = () => {
        setOpenToggleModelForUpload(false)
        setFiles([])
    }


    const filterChange = (e) => {
        const value = e.filter.value || '';
        const newData = supplierOptions.filter((item) => {
            if (Number(value)) {
                return item?.SupplierId !== null && String(item?.SupplierId).includes(String(value))
            }
            return item?.SupplierName != null && item?.SupplierName?.toString()?.toLowerCase()?.includes(value?.toLowerCase());
        })
        setFilterSupplierOptions(newData)
    }

    const fetchDataForPagination = async (event, type) => {
        setFilterValueArticle('')
        if (currArticleNo && userData && selectedRegion && !loading) {
            setLoading(true)
            let skip = 0
            let take = 100;
            let filters = {}
            let changePagination = false
            if (type === "PAGINATION") {
                skip = event?.page?.skip;
                take = event?.page?.take;
                filters = dataState?.filter || { logic: "and", filters: [] }
            }
            else {
                skip = dataState?.skip;
                take = dataState?.take;
                filters = event?.filter || { logic: "and", filters: [] }
                changePagination = true
            }
            const page = (skip / take) + 1
            const pageSize = take
            const articleNo = currArticleNo
            const supplierId = selectedSupplierOption?.SupplierId;
            const supplierName = selectedSupplierOption?.SupplierName || '';
            const region = selectedRegion?.value
            const CurrentLanguage = i18n.language
            const response = await getArticleDataBypagination({ userData, articleNo, supplierId, region, CurrentLanguage, supplierName, page, pageSize, filters, changePagination })
            if (response?.status === 401 || response?.error?.statusCode === 401) {
                localStorage.removeItem("userData")
                navigate('/login')
                toast.error('Session Expired.')
            }
            else if (response && response?.data?.VehicleDetails.length > 0) {
                let newPage = ((response?.pagination?.currentPage - 1) * (response?.pagination?.pageSize || 100));
                setDataState((prevState) => ({

                    ...prevState,

                    take: take,

                    skip: newPage,

                }));
                const fetchData = Array.isArray(response.data?.VehicleDetails) ? response?.data?.VehicleDetails : [];
                const fetchedData = fetchData.map((item) => {
                    const formattedItem = { ...item };

                    if (item?.DateFrom) {
                        const formattedDateFrom = `${item.DateFrom.slice(0, 4)}-${item.DateFrom.slice(4, 6)}-01`;
                        formattedItem.DateFrom = formattedDateFrom;
                    }

                    if (item?.DateTo) {
                        const formattedDateTo = `${item.DateTo.slice(0, 4)}-${item.DateTo.slice(4, 6)}-01`;
                        formattedItem.DateTo = formattedDateTo;
                    }

                    return formattedItem;
                });


                setVehicleData(fetchedData || [])
                setFilteredData(fetchedData || [])
                const newDataResult = processWithGroups(fetchedData, {
                    ...dataState,
                    take: take || 100,
                    skip: 0
                });
                setDataResult(newDataResult)
                setIsDataAvailable(fetchedData.length > 0)
                const attributes = response?.data?.ArticleAttributes;
                if (attributes && attributes !== null && attributes !== undefined) {
                    const arrayAttributes = Object.entries(attributes).filter(([key]) => key !== 'ArticleNoCompressed').map(([key, value]) => {
                        if (key === "ArticleNo") {
                            return {
                                key: "Article No",
                                value: value || ''
                            }
                        }
                        if (key === "ArticleName") {
                            return {
                                key: "Article Name",
                                value: value || ''
                            }
                        }
                        if (key === "SupplierName") {
                            return {
                                key: "Supplier Name",
                                value: value || ''
                            }
                        }
                        else {
                            return {
                                key,
                                value: value || ''
                            }
                        }
                    })
                    setSupplierAttributes(arrayAttributes)
                }
                setCurrArticleName(response?.data?.ArticleAttributes?.ArticleName || '')
                const totalLength = response?.data?.TotalVehicleCount;
                setTotalLength(totalLength.toLocaleString('en-IN') || 0)
                const totalRecords = response?.pagination?.totalRecords || 0
                setTotalGridLength(totalRecords)
                if (fetchedData.length > 0) {
                    const fields = Object.keys(fetchedData[0])
                    const orderKeys = Object.keys(mappingFields)
                    const columnMeta = await orderKeys.filter((key) => fields?.includes(key)).map((item) => ({
                        field: item,
                        title: mappingFields[item].value,
                        width: mappingFields[item].width
                    }))
                    SetColumnFields(columnMeta)
                }
                else {
                    toast('No Data Found', {
                        type: "error",
                        autoClose: true,
                    })
                }
            }
            else {
                setDataResult([])
                setFilteredData([])
                setVehicleData([])
                setIsDataAvailable(false)
                setFilterValueArticle('')
                toast('No Data Found', {
                    type: "error",
                    autoClose: true,
                })
            }
            setLoading(false);
        }
    }

    const fetchData = async () => {
        if (checkSupplierValidation() && userData && selectedRegion && !loading) {
            setFilterValueArticle('')
            setLoading(true)
            const pageSize = dataState?.take
            const page = 1
            const pureString = filterString(filterValue)
            setCurrArticleNo(pureString)
            const articleNo = filterString(pureString);
            setFilterValue(pureString)
            setIsButtonClicked(true)
            const supplierId = selectedSupplierOption?.SupplierId;
            const supplierName = selectedSupplierOption?.SupplierName || '';
            const region = selectedRegion?.value
            const CurrentLanguage = i18n.language
            setDataState((prev) => ({
                ...prev,
                filter: { logic: "and", filters: [] },
                sort: [],
                group: []
            }))
            try {
                const response = await getArticleData({ userData, articleNo, supplierId, region, CurrentLanguage, supplierName, pageSize, page })
                if (response?.status === 401 || response?.error?.statusCode === 401) {
                    localStorage.removeItem("userData")
                    navigate('/login')
                    toast.error('Session Expired.')
                }
                else if (response && response?.data?.VehicleDetails.length > 0) {
                    const fetchData = Array.isArray(response.data?.VehicleDetails) ? response?.data?.VehicleDetails : [];
                    const fetchedData = fetchData.map((item) => {
                        const formattedItem = { ...item };

                        if (item?.DateFrom) {
                            const formattedDateFrom = `${item.DateFrom.slice(0, 4)}-${item.DateFrom.slice(4, 6)}-01`;
                            formattedItem.DateFrom = formattedDateFrom;
                        }

                        if (item?.DateTo) {
                            const formattedDateTo = `${item.DateTo.slice(0, 4)}-${item.DateTo.slice(4, 6)}-01`;
                            formattedItem.DateTo = formattedDateTo;
                        }

                        return formattedItem;
                    });


                    setVehicleData(fetchedData || [])
                    setFilteredData(fetchedData || [])
                    setDataResult(processWithGroups(fetchedData, {
                        ...initialDataState,
                        take: dataState?.take || 100,
                        group: [],
                        skip: 0
                    }));
                    setDataState((prevState) => ({
                        ...prevState,
                        filter: { filters: [], logic: "and" },
                        skip: 0
                    }))
                    setIsDataAvailable(fetchedData.length > 0)
                    const attributes = response?.data?.ArticleAttributes;
                    if (attributes && attributes !== null && attributes !== undefined) {
                        const arrayAttributes = Object.entries(attributes).filter(([key]) => key !== 'ArticleNoCompressed').map(([key, value]) => {
                            if (key === "ArticleNo") {
                                return {
                                    key: "Article No",
                                    value: value || ''
                                }
                            }
                            if (key === "ArticleName") {
                                return {
                                    key: "Article Name",
                                    value: value || ''
                                }
                            }
                            if (key === "SupplierName") {
                                return {
                                    key: "Supplier Name",
                                    value: value || ''
                                }
                            }
                            else {
                                return {
                                    key,
                                    value: value || ''
                                }
                            }
                        })
                        setSupplierAttributes(arrayAttributes)
                    }
                    setCurrArticleName(response?.data?.ArticleAttributes?.ArticleName || '')
                    const totalLength = response?.data?.TotalVehicleCount;
                    setTotalLength(totalLength.toLocaleString('en-IN') || 0)
                    const totalRecords = response?.pagination?.totalRecords || 0
                    setTotalGridLength(totalRecords)
                    if (fetchedData.length > 0) {
                        const fields = Object.keys(fetchedData[0])
                        const orderKeys = Object.keys(mappingFields)
                        const columnMeta = await orderKeys.filter((key) => fields?.includes(key)).map((item) => ({
                            field: item,
                            title: mappingFields[item].value,
                            width: mappingFields[item].width
                        }))
                        SetColumnFields(columnMeta)
                    }
                    else {
                        toast('No Data Found', {
                            type: "error",
                            autoClose: true,
                        })
                    }
                }
                else {

                    setDataResult([])
                    setFilteredData([])
                    setVehicleData([])
                    setIsDataAvailable(false)
                    setCurrArticleName('')
                    setCurrArticleNo('')
                    setTotalLength(0)
                    SetColumnFields([])
                    setFilterValue('')
                    setSupplierAttributes([])
                    setFilterValueArticle('')
                    setSelectedSupplierOption({ SupplierId: null, SupplierName: 'Select a supplier...' })
                    toast('No Data Found', {
                        type: "error",
                        autoClose: true,
                    })
                }
            }
            catch (error) {

                const errorStatus = error.status || null;
                if (errorStatus === 401 || error?.statusCode === 401) {
                    localStorage.removeItem('userData')
                    navigate('/login')
                    History.push("/login")
                    toast('Session Expired.', {
                        autoClose: true,
                        type: 'error'
                    })
                    return;
                }
                else {
                    setDataResult([])
                    setFilteredData([])
                    setVehicleData([])
                    setIsDataAvailable(false)
                    setCurrArticleName('')
                    setCurrArticleNo('')
                    setTotalLength(0)
                    SetColumnFields([])
                    setFilterValue('')
                    setSupplierAttributes([])
                    setFilterValueArticle('')
                    setSelectedSupplierOption({ SupplierId: null, SupplierName: 'Select a supplier...' })
                    toast('No Data Found', {
                        type: "error",
                        autoClose: true,
                    })
                }
            }
            finally {
                setLoading(false);
            }
        }
    }

    useEffect(() => {
        // Function to handle language change

        const handleLanguageChange = () => {
            if (filteredData.length > 0) {
                // Refetch data when language changes
                fetchData();
            };
        }

        // Add event listener for language changes
        i18n.on('languageChanged', handleLanguageChange);

        // Clean up the event listener when component unmounts
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n, fetchData]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (popupRef.current && !popupRef.current.contains(e.target) && !anchorRef.current.contains(e.target)) {
                setShow(false)
            }
        }
        document.addEventListener("mousedown", handleClickOutside)
        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        };
    }, [])

    const checkSupplierValidation = () => {
        const regex = /^[a-zA-Z0-9.\-\\]*$/;
        if (!regex.test(filterValue)) {
            setInputError(true)
            toast('Please Enter valid Article Number', {
                type: 'error',
                autoClose: true
            })
            return false
        }
        if (filterValue === null || filterValue.length === 0) {
            setInputError(true)
            toast('Please Enter Article Number', {
                type: 'error',
                autoClose: true
            })
            return false;
        }
        if (selectedRegion === null || selectedRegion === undefined) {
            toast('Please Select Region', {
                type: 'error',
                autoClose: true
            })
            return false
        }
        if (selectedSupplierOption.SupplierId === null || selectedSupplierOption.SupplierName.length === 0) {
            toast('Please Select Supplier', {
                type: 'error',
                autoClose: true
            })
            return false;
        }
        setInputError(false)
        return true;
    }



    const supplierOptionsOnChnage = (e) => {
        setSelectedSupplierOption(e.target.value)
    }

    const exportComplete = () => {
        setLoading(false)
        toast("Excel Exported Successfully", { type: "success", autoClose: true });
    }

    const toggleDialog = useCallback(() => {
        setVisible(false);
    }, []);

    const onFilterChangeSupplier = (ev) => {
        const value = ev ? ev.value : '';
        setFilterValueArticle(value);
        const newData = vehicleData.filter((item) => {
            return Object.values(item).some(property => {
                return property !== null && property.toString().toLowerCase().includes(value.toLowerCase())
            })
        })
        setFilteredData(newData)
        setDataResult(process(newData, { ...dataState, skip: 0 }))
        setData(newData)
    }

    const onExpandChange = useCallback(event => {
        const item = event.dataItem;
        if (item.groupId) {
            const collapsedIds = !event.value ? [...collapsedState, item.groupId] : collapsedState.filter(groupId => groupId !== item.groupId);
            setCollapsedState(collapsedIds);
        }
    }, [collapsedState]);



    const newData = setExpandedState({
        data: dataResult.data || [],
        collapsedIds: collapsedState
    });

    const onPageChange = (event) => {
        setDataState((prevState) => ({
            ...prevState,
            take: event?.page?.take || 100,
            skip: event?.page?.skip || 0
        }))
        const type = "PAGINATION"
        fetchDataForPagination(event, type)
    }

    const onFilterChangeForAll = (event) => {
        const currentSkip = dataState?.skip || 0
        const currentTake = dataState?.take || 100
        setDataState((prevState) => ({
            ...prevState,
            filter: event?.filter,
            take: currentTake,
            skip: currentSkip
        }))
        const type = "FILTERATION"
        fetchDataForPagination(event, type)
    }

    const fetchDataForCSV = async () => {
        setLoading(true)
        const pureString = filterString(filterValue)
        const articleNo = filterString(pureString);
        const supplierId = selectedSupplierOption?.SupplierId;
        const supplierName = selectedSupplierOption?.SupplierName || '';
        const region = selectedRegion?.value
        const CurrentLanguage = i18n.language
        const body = {
            region,
            articleNo,
            supplierId,
            supplierName,
            CurrentLanguage,
            isVIOExport: true,
            filters: dataState?.filter
        }
        try {
            const getExcelExportResponse = await exportArticleData({ userData, body })
            if (getExcelExportResponse?.status === 401 || getExcelExportResponse?.error?.statusCode === 401) {
                localStorage.removeItem("userData")
                navigate('/login')
                toast.error('Session Expired.')
                setLoading(false)
                return { success: false, data: [] }
            }
            else if (getExcelExportResponse?.status !== 200) {
                toast(getExcelExportResponse?.message, {
                    type: "info",
                    autoClose: true
                })
                setLoading(false)
                return { success: false, data: [] }
            }
            else if (getExcelExportResponse?.status === 200) {
                toast(getExcelExportResponse?.message, {
                    type: "success",
                    autoClose: true
                })
                setLoading(false)
                return { success: true, data: getExcelExportResponse?.data };
            }
            else {
                toast.error('Failed to fetch data for CSV export.');
                setLoading(false)
                return { success: false, data: [] }
            }
        } catch (error) {
            setLoading(false)
            console.error('Error fetching data for CSV:', error);
            toast.error('Error fetching data for CSV export.');
            return { success: false, data: [] }
        }
    };



    const handleExportCsv = async () => {
        try {
            setLoading(true);

            // Prepare main data
            const headers = Object.keys(mappingFields).map((key) => ({
                label: mappingFields[key].value,
                key: key,
            }));

            const dataStateForExport = {
                ...dataState,
                skip: 0,
                take: Number.MAX_SAFE_INTEGER,
            };

            const getExcelExportResponse = await fetchDataForCSV()
            if (getExcelExportResponse.success === false) {
                setLoading(false)
                return;
            }

            let processedData = getExcelExportResponse.data;
            if (dataStateForExport?.filter?.filters.length > 0) {
                processedData = applyFilter(processedData, dataStateForExport?.filter.filters, dataStateForExport?.filter.filters.logic);
            }

            if (dataStateForExport.group.length > 0) {
                const filteredAndGroupedData = process(processedData, dataStateForExport);
                processedData = dataState.group && dataState.group.length > 0 ? flatternGroup(filteredAndGroupedData.data) : processedData;
            }
            if (dataStateForExport?.sort?.length > 0) {
                processedData = applySort(processedData, dataStateForExport.sort);
            }

            if (processedData.length === 0) {
                toast("No data available for export", { type: "warning", autoClose: true });
                setLoading(false);
                return;
            }




            const sheet2Data = supplierAttributes.map(attr => ({
                Attribute: `"${attr.key.replace(/"/g, '""')}"`, // Add quotes and escape existing quotes
                Value: `"${String(attr.value).replace(/"/g, '""')}"`, // Add quotes and escape existing quotes
            }));

            // Function to create CSV string
            const createCsvString = (data, headers) => {
                return [
                    headers.map(header => `"${header.label.replace(/"/g, '""')}"`).join(','), // Header row with quotes
                    ...data.map(row => headers.map(header => {
                        const value = row[header.key] != null ? row[header.key].toString().replace(/"/g, '""') : '';
                        return `"${value}"`; // Enclose in quotes and escape any quotes
                    }).join(',')) // Data rows
                ].join('\n');
            };

            // Create CSV for main data
            const csvData = processedData.map(item => {
                return Object.keys(mappingFields).reduce((acc, key) => {
                    const value = item[key] != null ? item[key].toString().replace(/"/g, '""') : '';
                    acc[key] = `"${value}"`; // Enclose in quotes and escape any quotes
                    return acc;
                }, {});
            });

            const mainCsvString = createCsvString(csvData, headers);

            // Create CSV for supplier attributes
            const supplierHeaders = [
                { label: "Attribute", key: "Attribute" },
                { label: "Value", key: "Value" },
            ];
            const supplierCsvString = createCsvString(sheet2Data, supplierHeaders);

            // Combine both CSV strings
            const combinedCsvString = `${mainCsvString}\n\nSupplier Attributes\n${supplierCsvString}`;
            const combinedBlob = new Blob([combinedCsvString], { type: 'text/csv;charset=utf-8;' });
            const combinedUrl = URL.createObjectURL(combinedBlob);

            const combinedLink = document.createElement('a');
            combinedLink.href = combinedUrl;
            combinedLink.setAttribute('download', `${currArticleNo}_${currArticleName}.csv`);
            document.body.appendChild(combinedLink);
            combinedLink.click();
            document.body.removeChild(combinedLink);

            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error('Error exporting CSV:', error);
        }
    };
    return (
        <div style={{ position: 'relative', height: '100%' }}>
            <LoaderOverlay loading={loading} />
            <ExcelExport data={[]} ref={excelExportRef} fileName={`${currArticleNo}_${currArticleName}.xlsx`} onExportComplete={exportComplete}>
                <Grid
                    // style={{ height: '100%' }}
                    pageable={isDataAvailable ? {
                        buttonCount: 4,
                        pageSizes: [100, 200, 500, 1000],
                    } : false}
                    data={newData}
                    skip={dataState?.skip}
                    take={dataState?.take}
                    total={totalGridLength}
                    group={dataState?.group}
                    sortable={isDataAvailable}
                    onExpandChange={onExpandChange}
                    onPageChange={onPageChange}
                    onFilterChange={onFilterChangeForAll}
                    groupable={isDataAvailable}
                    expandField='expanded'
                    style={{
                        height: '100%',
                        transition: 'opacity 0.2s ease-in-out',
                    }}
                    onDataStateChange={dataStateChange}
                    {...dataState}
                    dataItemKey={DATA_ITEM_KEY}
                >
                    <GridToolbar>
                        <div className='header-div'>
                            <div className='input-filter'>
                                <Input
                                    type="text"
                                    value={filterValue ?? ''}
                                    onChange={ev => onFilterChange(ev)}
                                    style={{ border: inputError ? '2px solid red' : '2px solid #ccc', width: '210px', height: '30px', marginRight: '10px' }}
                                    placeholder="Enter Article No..."
                                />
                                <DropDownList
                                    data={filterSupplierOptions}
                                    textField="SupplierName"
                                    dataItemKey="SupplierId"
                                    itemRender={itemRenderSupplier}
                                    value={selectedSupplierOption}
                                    valueRender={valueRenderSupplier}
                                    onChange={supplierOptionsOnChnage}
                                    filterable={true}
                                    onFilterChange={(e) => filterChange(e)}
                                    style={{ width: 'auto', minWidth: "200px", marginRight: '10px' }}
                                />
                                <DropDownList
                                    data={filteredRegions}
                                    textField="name"
                                    dataItemKey="id"
                                    itemRender={itemRender}
                                    valueRender={valueRender}
                                    value={selectedRegion}
                                    onChange={e => setSelectedRegion(e.target.value)}
                                    style={{ width: '150px', marginRight: '10px' }}
                                />
                                <Button style={{ color: "white", backgroundColor: "#1976d2" }} onClick={fetchData}>Search</Button>
                            </div>
                            <div className="export-btns-container" style={{ position: 'relative', gap: 2 }}>
                                {userData?.UserRole === "ROOT" && <div className="flex">
                                    <TooltipMUI title="Upload File">
                                        <span>
                                            <button onClick={handleOpenModalForUploadFile} className="bg-transparent border-none">
                                                <CloudUpload className="text-blue-500" sx={{ height: "31.5px", width: "31px", cursor: "pointer", verticalAlign: "-0.125em" }} />
                                            </button>
                                        </span>
                                    </TooltipMUI>
                                    <FileUpload openToggleModelForUpload={openToggleModelForUpload} handleCloseModalForUploadFile={handleCloseModalForUploadFile} files={files} setFiles={setFiles} userData={userData} selectedRegion={selectedRegion} setLoading={setLoading} />
                                </div>
                                }
                                <div>
                                    <TooltipMUI title={isDataAvailable ? "Download" : "No data available"}>
                                        <span>
                                            <TriggerButton
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    border: 'none',
                                                    cursor: isDataAvailable ? 'pointer' : 'not-allowed',
                                                    color: isDataAvailable ? "rgb(83, 83, 83)" : "rgb(189, 189, 189)",
                                                }}
                                                aria-describedby={id}
                                                type="button"
                                                onClick={isDataAvailable ? handlePopperToggle : undefined}
                                                disabled={!isDataAvailable}
                                            >
                                                <FontAwesomeIcon icon={faDownload} size="xl" />
                                            </TriggerButton>
                                        </span>
                                    </TooltipMUI>
                                    <Popper open={show} anchorEl={anchorRef.current} ref={popupRef} sx={{ top: "0px !important", left: "-10px !important" }} onClose={() => setShow(false)}>
                                        <StyledPopperDiv>
                                            <Button onClick={handleExportCsv}
                                                style={{ margin: '5px 0px' }} className="forFileExcel">
                                                <FontAwesomeIcon icon={faFileCsv} />
                                            </Button>
                                            <Button onClick={exportExcel} style={{ margin: '5px 0px' }} className="forFileExcel">
                                                <FontAwesomeIcon icon={faFileExcel} />
                                            </Button>
                                        </StyledPopperDiv>
                                    </Popper>
                                </div>
                            </div>
                        </div>
                    </GridToolbar>
                    <GridNoRecords>
                        {!isDataAvailable && !loading && isButtonClicked && (
                            <div className="no-data-found">
                                <div className="no-data-icon">
                                    <FontAwesomeIcon icon={faCircleExclamation} size="7x" />
                                </div>
                                <div className="no-data-message">
                                    No Data Available
                                </div>
                            </div>
                        )}
                        <></>
                    </GridNoRecords>
                    {columnFields.length > 0 && (
                        <GridToolbar>
                            <div className='header-div'>
                                <div className='header-article'>
                                    <div>
                                        <p>Article No : {currArticleNo}</p>
                                    </div>
                                    <div>
                                        <p>Article Name : {currArticleName}</p>
                                        <Tooltip anchorElement="target" position="bottom" parentTitle={true}>
                                            <button className="button-eye" title="Article Attributes" onClick={() => setVisible(true)}>
                                                <FaInfoCircle size={20} />
                                            </button>
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <p>Total Vehicle Count : {totalLength}</p>
                                    </div>
                                </div>
                                <div className='input-filter'>
                                    <Input
                                        type="text"
                                        value={filterValueArticle}
                                        onChange={onFilterChangeSupplier}
                                        style={{ border: '2px solid #ccc', width: '210px', height: '30px', marginRight: '10px' }}
                                        placeholder="Search in all columns..."
                                    />
                                </div>

                            </div>
                        </GridToolbar>
                    )
                    }
                    {columnFields.length > 0 ? (
                        columnFields.map((col, index) => (
                            <Column
                                key={index}
                                field={col.field}
                                title={col.title}
                                width={col.width}
                                columnMenu={ColumnMenu}
                            />
                        )

                        )) : (
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>No data available</div>
                    )})
                </Grid>
            </ExcelExport>

            {
                visible && (
                    <Dialog onClose={toggleDialog} >
                        <div className='dialog-api-main-second'  >
                            <button className="close-icon" onClick={toggleDialog}>
                                <MdClose size={22} />
                            </button>
                            <div className='dialog-api-header'>
                                <h2>Article Attributes</h2>
                            </div>
                            <div className='dialog-api-table'>
                                <Grid
                                    data={supplierAttributes}
                                    style={{ maxHeight: '500px' }}
                                >
                                    <GridColumn field="key" title="Attribute" />
                                    <GridColumn field="value" title="Value" />
                                </Grid>
                            </div>
                        </div>
                    </Dialog>
                )
            }


        </div >
    );
}

const ColumnMenu = (props) => {
    return (
        <div>
            <GridColumnMenuSort {...props} />
            <GridColumnMenuFilter {...props} />
            <GridColumnMenuGroup {...props} />
        </div>
    );
};


const TriggerButton = styled('button')(
    ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 5px 5px;
  background-color: transparent;
  border-radius: 8px;
  color: grey[500];
  transition: all 150ms ease;
  cursor: pointer;
  border: none;
  box-shadow: none;

  &:focus-visible {
    box-shadow: 0 0 0 4px ${theme.palette.mode === 'dark' ? grey[300] : grey[200]};
    outline: none;
  }

  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    box-shadow: none;

    &:hover {
      background-color: ${grey[500]};
    }
  }
`
);

const StyledPopperDiv = styled('div')(
    ({ theme }) => css`
    background-color: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border-radius: 8px;
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: ${theme.palette.mode === 'dark'
            ? `0px 4px 8px rgb(0 0 0 / 0.7)`
            : `0px 4px 8px rgb(0 0 0 / 0.1)`};
    padding: 10px;
    color: ${theme.palette.mode === 'dark' ? grey[100] : grey[700]};
    font-size: 0.875rem;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    opacity: 1;
    margin: 0.25rem 0;
  `
);




export default ArticlePage